import { IApplicationState } from '../../types/redux';

export const selectLkType = (state: IApplicationState) => state.lkType;
